import Vue from 'vue';
import Router from 'vue-router';
import BaseApi from '@lib/baseApi.js';
Vue.use(Router);
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

import PersonalRouter from './router/personal'; //登录后的页面的路由

const HelloWorld = (r) =>
  require.ensure(
    [],
    () => r(require('./components/HelloWorld.vue')),
    'helloWorld',
  );
const pdf = (r) =>
  require.ensure([], () => r(require('./components/pdf.vue')), 'pdf');
const tro = (r) =>
  require.ensure([], () => r(require('./components/tro.vue')), 'tro');
const Home = (r) =>
  require.ensure([], () => r(require('./components/home/Home.vue')), 'home');

const DepositCertificate = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/deposit/depositCertificate.vue')),
    'depositCertificate',
  );
const Signing = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/deposit/signing.vue')),
    'Signing',
  );
const Transfer = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/deposit/transfer.vue')),
    'Transfer',
  );
const PersonalCenter = (r) =>
  require.ensure(
    [],
    () => r(require('./components/personal/PersonalCenter.vue')),
    'personalIndex',
  );
const Verification = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/Verification.vue')),
    'Verification',
  );
const About = (r) =>
  require.ensure([], () => r(require('./components/home/About.vue')), 'About');
const MobileAbout = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/mobileAbout.vue')),
    'MobileAbout',
  );
const LookCertificate = (r) =>
  require.ensure(
    [],
    () => r(require('./components/personal/sign/lookCertificate.vue')),
    'LookCertificate',
  );

const Login = (r) =>
  require.ensure([], () => r(require('./components/home/Login.vue')), 'Login');
const Solution = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/Solution.vue')),
    'Solution',
  );

const HelpCenter = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/helpCenter.vue')),
    'HelpCenter',
  );
const ToolPosition = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/toolPosition.vue')),
    'HelpCenter',
  );
const Register = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/Register.vue')),
    'Register',
  );
const Validate = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/Validate.vue')),
    'Validate',
  );
const ValidateResult = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/validate/validateResult.vue')),
    'ValidateResult',
  );

const Forgetpwd = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/register/Forgetpwd.vue')),
    'Forgetpwd',
  ); //忘记密码
const paySuccess = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/paySuccess.vue')),
    'paySuccess',
  ); //忘记密码

// 调赋一体化
// 登录
const IntegrationLogin = (r) =>
  require.ensure(
    [],
    () => r(require('./components/integration/login/index.vue')),
    'IntegrationLogin',
  );
const InitiationSingle = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/initiation/single.vue')),
    'IntegrationLogin',
  );
const InitiationBatch = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/initiation/batch.vue')),
    'IntegrationLogin',
  );

const SignMediateBatch = (r) =>
  require.ensure(
    [],
    () => r(require('./components/personal/sign/components/initiateContract/SignatureMediateBatch.vue')),
    'SignMediateBatch',
  );

const OutsideAgencies = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/businessManagement/outsideAgencies.vue')),
    'OutsideAgencies',
  );

const BusinessDetail = (r) =>
  require.ensure(
    [],
    () => r(require('./components/home/businessDetail/index.vue')),
    'BusinessDetail',
  );

  const Jwxa = (r) => {
    require.ensure(
      [],
      () => r(require('./components/jwxa/index.vue')),
      'Jwxa',
    );
  }

let router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/world',
      component: HelloWorld, //demo用，暂时别删
    },
    {
      path: '/tro',
      component: tro, //拖拽
    },
    {
      path: '/pdf',
      component: pdf, //拖拽
    },
    {
      path: '/index',
      component: Home,
      children: [
        {
          path: 'depositCertificate',
          component: DepositCertificate,
          name: 'DepositCertificate',
        },
        {
          path: 'signing',
          component: Signing,
          name: 'Signing',
        },
        {
          path: 'transfer',
          component: Transfer,
          name: 'Transfer',
        },
      ],
    },
    {
      path: '/lookCertificate',
      component: LookCertificate,
    },
    {
      path: '/solution',
      component: Solution,
    },
    {
      path: '/verification',
      component: Verification,
      children: [
        {
          path: 'about',
          component: About,
        },

        {
          path: 'validate',
          component: Validate,
        },
        {
          path: 'validateResult',
          component: ValidateResult,
        },
        {
          path: 'login',
          component: Login,
        },
        {
          path: 'paySuccess',
          component: paySuccess,
        },
        {
          path: 'register',
          component: Register,
        },
        {
          path: 'forgetpwd',
          component: Forgetpwd,
        },
        {
          path: 'helpCenter',
          component: HelpCenter,
        },
        {
          path: 'toolPosition',
          component: ToolPosition,
        },
      ],
    },
    {
      path: '/personal',
      component: PersonalCenter,
      children: [PersonalRouter],
    },
    {
      path: '/mobileAbout',
      component: MobileAbout,
    },

    // 调赋一体化 登录
    {
      path: '/integration/login',
      component: IntegrationLogin,
    },
    // 赋强发起
    {
      path: '/initiation/single',
      component: InitiationSingle,
    },
    // 批量发起
    {
      path: '/initiation/batch',
      component: InitiationBatch,
    },
    //批量签署页面
    {
      path: '/personal/sign/signMediateBatch',
      component: SignMediateBatch
    },
    // 业务管理 外部机构
    {
      path: '/personal/businessManagement/outsideAgencies',
      component: OutsideAgencies
    },
    // 业务详情
    {
      path: '/personal/businessDetail',
      component: BusinessDetail
    },
    {
      path: '/jwxa/:pagePath',
      component: Jwxa
    }
  ],
});
// 拦截所有前端请求
router.beforeEach((to, from, next) => {
  console.log(to, 'to')
  if (sessionStorage.getItem("userInfo")) {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (userInfo.currentUserRoleCode === 'ASSISTANT' && 
    (to.path === '/personal/home' || to.path === '/personal/users/home')) {
      // 机构业务人员
      console.log('机构业务人员')
      next('/personal/businessManagement/outsideAgencies')
      return;
    }
  }

  let ENABLEINTEGRATION = JSON.parse(
    sessionStorage.getItem('ENABLEINTEGRATION'),
  ) || {
    flag: 0,
    value: null, // 调赋一体化
  };
  if (ENABLEINTEGRATION.value === true) {
    // 调赋一体化开关打开
    if (to.query.ht) {
      localStorage.setItem('token', to.query.ht);
    }
  }
  if (to.query.role) {
    sessionStorage.setItem('role', to.query.role)
  }
  if (to.query.tjFlag) {
    localStorage.setItem('tjFlag', 1);
  }
  if (!ENABLEINTEGRATION.flag) {
    BaseApi.createRpcToken(
      '/common/getSysConfigByKey',
      {
        configKey: 'enableXconIntegration',
      },
      'post',
      '',
      '',
      false,
    )
      .then(
        (data) => {
          console.log(data, 'data');
          // data.datas.configValue = null; // TODO要删掉
          if (data.code === 200) {
            if (data && data.datas && data.datas.configValue) {
              ENABLEINTEGRATION = {
                flag: 1,
                value: data.datas.configValue === 'true' ? true : false,
              };
              sessionStorage.setItem(
                'ENABLEINTEGRATION',
                JSON.stringify(ENABLEINTEGRATION),
              );
              if (ENABLEINTEGRATION.value === true) {
                // 调赋一体化开关打开
                if (to.query.ht) {
                  localStorage.setItem('token', to.query.ht);
                }
              }
            }
          }
          next();
        },
        (err) => {
          next();
        },
      )
      .catch(function (e) {
        next();
      });
  } else {
    next();
  }
});

// 处理懒加载导致路由跳转问题
// router.onError((error) => {
//   const targetPath = router.history.pending.fullPath;
//   window.location.href = targetPath;
//   if (bowser.msie) {
//     window.location.reload();
//   }
// });
export default router;
